"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var iconList_json_1 = __importDefault(require("./iconList.json"));
var IonIcon = function (props) { return (react_1.default.createElement("span", __assign({}, props, { style: __assign({ display: 'inline-block', height: props.size ? (props.size == 'small' ? '.5em' : '2em') : '1em', width: props.size ? (props.size == 'small' ? '.5em' : '2em') : '1em', visibility: 'inherit', fill: 'currentcolor', boxSizing: 'content-box', stroke: 'currentcolor' }, props.style), dangerouslySetInnerHTML: { __html: iconList_json_1.default[props.name] } }))); };
exports.default = IonIcon;
